import { Palette } from '@mui/material'

export const backButtonStyles = (palette: Palette) => ({
	backgroundColor: 'white',
	borderColor: palette.text.lightGrey,
	height: '48px',
	fontSize: '14px',
})

export const continueButtonStyles = (palette: Palette) => ({
	backgroundColor: palette.brand.main,
	height: '48px',
	flexGrow: 1,
	fontSize: '14px',
})
